import { css, html, LitElement } from "lit";
import { customElement } from "lit/decorators.js";
import * as Styles from "../../styles.ts";

const styles = css`
  :host {
    --min-height: 80px;
    display: block;
    width: 100%;
  }

  .artifact-card {
    border: 1px solid var(--border);
    cursor: pointer;
    border-radius: var(--radius-md);
    min-height: var(--min-height);
    display: flex;
    flex-direction: column;
    justify-content: center;
    overflow: hidden;
    transition-property: border-color, opacity;
    transition-duration: var(--duration-normal);
    transition-timing-function: ease-in-out;
    width: 100%;
  }

  .artifact-card:hover {
    border-color: var(--accent);
  }

  :host([disabled]) .artifact-card {
    opacity: 0.5;
    pointer-events: none;
  }

  .artifact-card-body {
    display: flex;
    flex-direction: column;
    gap: 2px;
    padding: var(--space-4);
    overflow: hidden;
  }

  .artifact-card-title ::slotted(*) {
    font-weight: 600;
  }

  .artifact-card-content ::slotted(*) {
    color: var(--muted-foreground);
  }
`;

@customElement("artifact-card")
export class ArtifactCard extends LitElement {
  static override styles = [Styles.base, styles];

  override render() {
    return html`
      <article class="artifact-card">
        <div class="artifact-card-body">
          <div class="artifact-card-title">
            <slot name="title"></slot>
          </div>
          <div class="artifact-card-content">
            <slot></slot>
          </div>
        </div>
      </article>
    `;
  }
}
